module.exports = __webpack_public_path__ + "img/emoji_27.da9d9658.png";